/* ==========================================================================
   OSERE — Header

   Dos comportamientos, ninguno reimplementa nada de Dawn:

   1. Marca el header cuando la página se ha separado del tope, para que pase
      de fondo sólido a translúcido con desenfoque y se contraiga.
   2. Marca el drawer cuando está abierto, para escalonar la entrada de los
      ítems del menú.

   Sin listener de scroll: se usa un centinela de 1px con IntersectionObserver,
   que no obliga al navegador a recalcular en cada frame.
   ========================================================================== */

(function () {
  'use strict';

  var wrapper = document.querySelector('.header-wrapper');
  if (!wrapper) return;

  /* ---- 1. Estado "desplazado" ------------------------------------------ */

  /* Marca que el JS del header está vivo. El CSS solo esconde los ítems del
     drawer si esta clase existe: sin script, el menú se ve completo. */
  document.documentElement.classList.add('os-h-js');

  var centinela = document.createElement('div');
  centinela.setAttribute('aria-hidden', 'true');
  centinela.style.cssText = 'position:absolute;top:0;left:0;width:1px;height:1px;pointer-events:none;';
  document.body.insertBefore(centinela, document.body.firstChild);

  /* Solo escribe cuando el valor cambia. Es lo que evita que el
     MutationObserver de más abajo se realimente con sus propias escrituras. */
  function marcar(desplazado) {
    if (wrapper.classList.contains('os-h-desplazado') === desplazado) return;
    wrapper.classList.toggle('os-h-desplazado', desplazado);
  }

  /* ⚠️ EL UMBRAL LO MANDA DAWN, NO NOSOTROS.

     Antes esto era `scrollY > 4`, y ahí estaba el corte que se veía al bajar.

     Dawn conmuta su propio estado sticky —el que cambia `position` y devuelve
     la superficie— cuando el scroll pasa `headerBounds.bottom`, que aquí son
     unos 105 px (41 de hueco sobre el hero + 64 de header). Medido el 27 ago.

     Con dos umbrales distintos había una ventana de ~100 px en la que el header
     YA se veía como píldora pero seguía en `position: absolute`, subiendo con
     la página. Al llegar a los 105 conmutaba a `fixed` y saltaba de golpe: la
     píldora pasaba de y=36 a y=8. Veintiocho píxeles de teletransporte, y eso
     es lo que se leía como un corte.

     Ahora el estado lo dicta la clase de Dawn, así que las dos cosas ocurren en
     el mismo fotograma por construcción y no hay forma de que se desincronicen
     si alguien cambia el tipo de sticky desde el personalizador.

     Se mantiene un respaldo por scrollY para las plantillas SIN hero, donde el
     header es sólido y Dawn no marca sticky nunca. */
  /* ⚠️ LA CLASE DE DAWN NO ESTÁ EN EL WRAPPER. Está en su PADRE.

     `.header-wrapper` es el propio `<sticky-header>`, y Dawn escribe
     `shopify-section-header-sticky` sobre `.section-header`, que es el div que
     lo contiene. Buscarla en el wrapper devuelve siempre false, y con eso la
     píldora no se encendía nunca: ni fondo, ni cristal, ni radio.

     Costó una regresión en producción. Si alguien vuelve a tocar esto, lo
     primero es comprobar SOBRE QUÉ ELEMENTO escribe Dawn, no suponerlo. */
  var seccion = wrapper.closest('.section-header');
  var conSticky = !!seccion && wrapper.matches('.os-h-transparente');

  function evaluar() {
    if (conSticky) {
      marcar(seccion.classList.contains('shopify-section-header-sticky'));
    } else {
      marcar((window.scrollY || document.documentElement.scrollTop || 0) > 4);
    }
  }

  if ('IntersectionObserver' in window) {
    new IntersectionObserver(evaluar, { threshold: 0 }).observe(centinela);
  }

  /* Red de seguridad: si el observer no llega a disparar, el header sigue
     respondiendo. passive para no bloquear el scroll.

     Sin requestAnimationFrame a propósito: rAF no se ejecuta con la pestaña en
     segundo plano, y un throttle basado en él se queda con el cerrojo echado
     para siempre — el header no volvería a reaccionar nunca. El trabajo aquí es
     leer scrollY y un classList.toggle, que es más barato que el propio gate. */
  window.addEventListener('scroll', evaluar, { passive: true });

  /* Dawn pone y quita su clase desde su propio manejador de scroll, así que el
     nuestro la ve como muy tarde en el evento siguiente. Un fotograma de
     desfase se nota justo en la conmutación, que es lo que estamos arreglando,
     así que además se observa el atributo `class` del wrapper.

     `marcar` solo toca la clase cuando el valor cambia de verdad, y por eso
     esto no entra en bucle: un toggle que no modifica el atributo no genera
     mutación. */
  if (conSticky && 'MutationObserver' in window) {
    new MutationObserver(evaluar).observe(seccion, {
      attributes: true,
      attributeFilter: ['class'],
    });
  }

  evaluar();

  /* ---- 2. Drawer abierto ------------------------------------------------ */

  var drawer = document.querySelector('header-drawer details');
  if (drawer) {
    var sincronizar = function () {
      document.documentElement.classList.toggle('os-h-drawer-abierto', drawer.open);
    };
    drawer.addEventListener('toggle', sincronizar);
    sincronizar();
  }
})();
